import { blockToolboxOptions } from '../../editor/block-toolbox-options'
import { BlockTypeIcon } from '../../editor/block-type-icon'
import { usePageEditorContext } from '../../contexts/page-editor.context'

import { useStyles } from './placeholder-block.style'
import { Button } from '#base/js/common/components/button'

/**
 * Temporary placeholder for chart blocks until we can render charts with sample data
 */
export const PlaceholderBlock = function ({ blockType, onEdit }) {
  const classes = useStyles()
  const pageEditorContext = usePageEditorContext()

  const block = blockToolboxOptions.find(({ type }) => type === blockType)

  if (!block || !pageEditorContext) {
    return null
  }

  let iconClassName = classes.cardIcon
  if (block.id === 'forest') {
    iconClassName = classes.forestIcon
  }
  if (block.id === 'sunburst') {
    iconClassName = classes.sunburstIcon
  }

  return (
    <div className={classes.placeholderContainer}>
      <BlockTypeIcon
        id={block.id}
        icon={block.icon}
        iconSize={40}
        primaryColor={block.primaryColor}
        secondaryColor={block.secondaryColor}
        className={iconClassName}
      />
      <div className={classes.displayName}>
        {block.displayName}
      </div>
      <div className={classes.editButton}>
        <Button variant="secondary" onClick={onEdit}>Edit</Button>
      </div>
    </div>
  )
}
